import { useState } from 'react';

import {
  Button,
  Icons,
  MetadataChipV2,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { metaTextLinkSx } from './_metaStyles';
import { MetaDetailRow } from './MetaDetailRow';

const LABEL_PREVIEW_COUNT = 15;

type LabelEntry = { key: string; value: string };

export const MetaLabelsSection = ({ labels }: { labels: LabelEntry[] }) => {
  const [showAll, setShowAll] = useState(false);

  const labelStrings = labels.map(({ key, value }) => `${key}=${value}`);
  const visible = showAll
    ? labelStrings
    : labelStrings.slice(0, LABEL_PREVIEW_COUNT);
  const hiddenCount = Math.max(labelStrings.length - LABEL_PREVIEW_COUNT, 0);

  return (
    <MetaDetailRow label={`Labels: ${labels.length}`} testId="meta-labels">
      {!labels.length ? (
        <Typography variant="P12R" color={tokens.theme.fg.structural.secondary}>
          —
        </Typography>
      ) : (
        <Stack
          direction="row"
          gap={4}
          flexWrap="wrap"
          alignItems="center"
          data-testid="meta-labels-content"
        >
          {visible.map((label) => (
            <MetadataChipV2
              key={label}
              label={label}
              size="l"
              variant="strong"
            />
          ))}
          {!showAll && hiddenCount > 0 ? (
            <Button
              variant="text"
              size="sm"
              onClick={() => setShowAll(true)}
              endIcon={<Icons.CaretDown size={16} weight="regular" />}
              testId="meta-labels-view-more"
              sx={{ ...metaTextLinkSx, px: 8 }}
            >
              view {hiddenCount} more
            </Button>
          ) : null}
        </Stack>
      )}
    </MetaDetailRow>
  );
};
